// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2cd4L","content":"RecentSearches_content__2LGQ3"};